// Simple global event bus using EventTarget
// Avoids external deps; works in browser and tests (jsdom)

const bus = new (typeof window !== 'undefined' && window.EventTarget
  ? window.EventTarget
  : class {
      constructor() {
        this._target = document.createElement('span');
      }
      addEventListener(...args) { this._target.addEventListener(...args); }
      removeEventListener(...args) { this._target.removeEventListener(...args); }
      dispatchEvent(...args) { return this._target.dispatchEvent(...args); }
    })();

export function on(eventName, handler) {
  const wrapped = (e) => handler(e?.detail);
  bus.addEventListener(eventName, wrapped);
  return () => bus.removeEventListener(eventName, wrapped);
}

export function emit(eventName, detail) {
  const evt = new CustomEvent(eventName, { detail });
  bus.dispatchEvent(evt);
}

export default { on, emit };

